module.exports = {"610125001":"甘亭街道办","610125101":"余下镇","610125102":"祖庵镇","610125103":"秦渡镇","610125104":"大王镇","610125105":"草堂镇","610125106":"蒋村镇","610125107":"庞光镇","610125108":"涝店镇","610125109":"甘河镇","610125110":"石井镇","610125111":"玉蝉镇","610125112":"五竹镇","610125114":"渭丰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610125.json
// module id = 2789
// module chunks = 0